const {minimize_str} = require("@core/helpers/string");

export const GET_WEB_PROJECT_SETTINGS_QUERY = minimize_str(`
  query ($keys: [String]) {
      getWebProjectSettings {
        lang {
          all_langs
        }
        currency
        storage_prefix_url
        update_status
      }
      webScripts: getSettingWebScripts {
        id
        strategy
        src
      }
      route_names: getRouteNames
      settings: getSettingByKeys (keys: $keys) {
        value
        key
      }
      config_keys: getSettingConfigKeys
  }
`);

